import { useQuery } from 'react-query';

import { ContactInquiry } from '../../type';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';


export const getContactInquiry = async (): Promise<ContactInquiry[]> => {
    const { data } = await axios.get(`v1/get-contact-inquiries`);
    return data.inquiries;
};

type QueryFnType = typeof getContactInquiry;

type UseCorpsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useContactInquiry = ({ config }: UseCorpsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['contactInquiry'],
        queryFn: () => getContactInquiry(),
    });
};
